import axios from 'axios';

/**
 * Resuelve dinámicamente la URL base del servicio de validación:
 * - Si existe una variable explícita REACT_APP_API_URL, se utiliza directamente.
 * - En caso contrario, se selecciona según el entorno REACT_APP_ENV (local | desa | prod):
 *   - Local: http://localhost:8080/qr/validar
 *   - DESA: http://192.168.60.74:8080/qr/validar (o IP del servidor Firmador-Desa)
 *   - PROD: https://disiprefecturaqr.prefecturanaval.gob.ar/qr/validar (DNS oficial sin -desa)
 */
const resolveApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  const env = (process.env.REACT_APP_ENV || 'local').toLowerCase();

  const urls = {
    local: process.env.REACT_APP_API_URL_LOCAL || 'http://localhost:8080/qr/validar',
    desa:  process.env.REACT_APP_API_URL_DESA  || 'http://192.168.60.74:8080/qr/validar',
    prod:  process.env.REACT_APP_API_URL_PROD  || 'https://disiprefecturaqr.prefecturanaval.gob.ar/qr/validar'
  };

  if (env === 'prod') return urls.prod;
  if (env === 'desa') return urls.desa;
  return urls.local;
};

const API_BASE_URL = resolveApiBaseUrl();

const qrService = async (param1, param2, param3) => {
  try {
    // Si vienen 3 argumentos: param1=tipo, param2=personaId, param3=id
    // Si vienen 2 argumentos: param1=personaId, param2=id (modo legado para Habilitaciones)
    let url;
    if (param3 !== undefined && param1) {
      url = `${API_BASE_URL}/${param1}/${param2}/${param3}`;
    } else {
      url = `${API_BASE_URL}/${param1}/${param2}`;
    }
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching QR data:', error);
    throw error;
  }
};

export default qrService;
